import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { signIn } from './auth';
import './styles.css';
import type { Environment } from './types';

async function start() {
    const env: Environment = await fetch('env.json').then((response) => response.json());
    await signIn(env);
    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <App env={env} />
        </StrictMode>,
    );
}

start();
